import { useMemo } from 'react';
import { useSelector } from 'react-redux';

// Defaults match Keys.java — safety net if /api/server doesn't return camera fields
const DEFAULTS = {
  videoServer: '94.130.17.48',
  videoPort: 10780,
  videoUrl: 'https://live.2ecomp.com',
};

export const useCameraServer = () => {
  const server = useSelector((state) => state.session.server);

  return useMemo(() => {
    const videoUrl = server?.cameraVideoUrl || DEFAULTS.videoUrl;
    const url = new URL(videoUrl);

    return {
      ip: server?.cameraVideoServer || DEFAULTS.videoServer,
      jt1078Port: server?.cameraVideoPort || DEFAULTS.videoPort,
      host: url.hostname,
      protocol: url.protocol.replace(':', ''),
      httpPort: url.port ? parseInt(url.port, 10) : (url.protocol === 'https:' ? 443 : 80),
      baseUrl: videoUrl,
      wssBaseUrl: videoUrl.replace('https://', 'wss://').replace('http://', 'ws://'),
    };
  }, [server?.cameraVideoServer, server?.cameraVideoPort, server?.cameraVideoUrl]);
};

export default useCameraServer;
